import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 1.5em;
  max-width: 400px;
  justify-items: center;

  ul > li > a {
    justify-content: center;
  }
`

export const ContinueGroup = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 2em;
  button {
    margin-bottom: 1em;
  }
  & > span {
    display: inline-block;
    max-width: 200px;
  }
`
